import { render } from "./mDetail.vue?vue&type=template&id=551b4b85&scoped=true"
import script from "./mDetail.vue?vue&type=script&lang=js"
export * from "./mDetail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551b4b85"]])

export default __exports__